module.exports = __webpack_public_path__ + "media/backvido.299adf8f.mp4";